var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMovError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1113 1.01148e-06H2.11133C1.00833 1.01148e-06 0.111328 0.894001 0.111328 1.992V14.008C0.111328 15.106 1.00833 16 2.11133 16H5.11133V20L11.4623 16H18.1113C19.2143 16 20.1113 15.106 20.1113 14.008V1.992C20.1097 1.46279 19.8983 0.95583 19.5233 0.582372C19.1483 0.208914 18.6405 -0.000531115 18.1113 1.01148e-06ZM14.8183 11.293L13.4043 12.707L10.1113 9.414L6.81833 12.707L5.40433 11.293L8.69733 8L5.40433 4.707L6.81833 3.293L10.1113 6.586L13.4043 3.293L14.8183 4.707L11.5253 8L14.8183 11.293Z",
    fill: "#F82D2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovError);
export default __webpack_public_path__ + "static/media/mov-error.b0896630.svg";
export { ForwardRef as ReactComponent };